export default "__VITE_ASSET__8vTmWcex__"